import React, { useEffect, useState } from "react";
import alertd from "../../assets/images/alertd.svg";
import arrowLeft from "../../assets/images/arrow-leftttttt.svg";
import { useNavigate, useParams } from "react-router-dom";
import { emergencyService } from "services/emergency.service";
import { paymnetService } from "services/payment.service";
import useCurrentUser from "hooks/useCurrentUser";
import { toast } from "react-toastify";

const DisasterAlert = () => {
  const { id } = useParams();
  const { user } = useCurrentUser();
  const [data, setData] = useState()
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  }
  const getemergencyDetails = async () => {
    const response = await emergencyService.emergencyListDetails(id)
    setData(response?.data?.data)
  }
  useEffect(() => {
    getemergencyDetails();
  }, [])

  const handlePayNow = async (emergency) => {
    try {
      const response = await paymnetService.createCheckoutSession({ type: 'Emergency', id: emergency?._id });
      response?.data?.data?.url && window.open(response?.data?.data?.url, '_blank');
    } catch (err) {
      toast.error(err.data.message);
    }
  }

  // Location (adjust field names to your API if needed)
  const latitude =
    data?.coordinates?.[1] ??
    null;

  const longitude =
    data?.coordinates?.[0] ??
    null;

  const hasLocation = latitude != null && longitude != null;

  return (
    <div>
      <div className="container-box">
        <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2>
            <img src={arrowLeft} className="me-3 cursor-pointer" onClick={handleBack} alt="" />Disaster Alert
          </h2>
        </div>
        <div className="outer-white pt-2">
          <div className="disaster-alert">
            <div className="alert-container">
              <div className="row gap-2">
                <div className="alert-column-1 text-center text-md-start p-3 text-center d-flex flex-column align-items-center bg-card-gray rounded-3">
                  <div className="alert-icon mx-auto mx-md-0">
                    <img src={alertd} alt="" />
                  </div>
                  <div className="alert-meta mt-2 text-center">
                    <div><strong>Type:</strong> {data?.type || '-'}</div>
                    <div><strong>Email:</strong> {data?.requesterEmail || '-'}</div>
                    <div><strong>Requester:</strong> {data?.requesterName || '-'}</div>
                    {data?.paymentStatus ? (
                      <div><strong>Payment Status:</strong> {data?.paymentStatus}</div>
                    ) : null}
                  </div>
                </div>

                <div className="alert-column-2 bg-card-gray rounded-3 p-4">
                  <h2 className="alert-title">Disaster Alert!</h2>
                  <p className="alert-description">{data?.description}</p>

                  {data?.rejectedReason ? (
                    <div className="mt-3">
                      <div className="fw-bold text-danger">Rejected</div>
                      <div>Reason: {data?.rejectedReason}</div>
                    </div>
                  ) : null}


                </div>

              </div>
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
                  <div>
                    <h6 className="mb-1">Last Known Location</h6>
                    <div className="small text-muted">
                      Coordinates and map preview
                    </div>
                  </div>
                  {hasLocation && (
                    <div className="small text-end">
                      <div>
                        <span className="text-muted">Lat: </span>
                        <strong>{latitude}</strong>
                      </div>
                      <div>
                        <span className="text-muted">Lng: </span>
                        <strong>{longitude}</strong>
                      </div>
                    </div>
                  )}
                </div>

                {data?.locationAddress && (
                  <div className="mb-2 small">
                    <span className="text-muted">Address: </span>
                    <strong>{data.locationAddress}</strong>
                  </div>
                )}

                {hasLocation ? (
                  <div className="rounded-3 overflow-hidden border">
                    <iframe
                      title="Last known location"
                      src={`https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
                      style={{ width: "100%", height: "260px", border: 0 }}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                ) : (
                  <div className="small text-muted">
                    Location coordinates are not available for this case.
                  </div>
                )}
              </div>
            </div>
          </div>
          {data?.requesterId === user?._id ? (
            <>
              {data?.paymentStatus === "Paid" ? (
                <div className="mt-3">Payment Status: Paid</div>
              ) : data?.paymentStatus === "UserDeny" ? (
                <div className="mt-3">Payment Status: Denied</div>
              ) : data?.isChargeRequestedByAdmin === true ? (
                <div className="d-flex gap-2 mt-3">
                  <button className="btn pay-btn blue-btn" onClick={() => handlePayNow(data)}>Pay Now</button>
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DisasterAlert;
